import {UsefulLinksListDefaultBox} from './useful-links-list.default.box';
import {styledByTheme} from '../../../../themes/architecture/styled-by-theme';
import {UsefulLinksListCipBox} from './useful-links-list.cip.box';

export const UsefulLinksListBox =  styledByTheme(UsefulLinksListDefaultBox)
                                    .forCip(UsefulLinksListCipBox)
                                    .forWsopCip(UsefulLinksListCipBox)
                                    .forCis(UsefulLinksListCipBox)
                                    .apply();